module.exports = __webpack_public_path__ + "static/NightInTheWoods1-c9effa78cd99bb5b8bc214558d1d9dda.png";